import { css } from '@stitches/core'
import { generateClassNames } from '@supabase/auth-ui-shared'
import { Appearance } from '../../types'

const messageDefaultStyles = css({
  fontFamily: '$bodyFontFamily',
  fontSize: '$baseBodySize',
  marginBottom: '$labelBottomMargin',
  display: 'block',
  textAlign: 'center',
  variants: {
    color: {
      default: {
        color: '#977',
      },
      danger: {
        color: '#932',
      },
    },
  },
})

interface MessageProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
  color?: 'default' | 'danger'
  appearance?: Appearance
}

const Message: React.FC<MessageProps> = ({
  children,
  appearance,
  ...props
}) => {
  const classNames = generateClassNames(
    'message',
    messageDefaultStyles({ color: props.color }),
    appearance,
  )

  return (
    <span
      {...props}
      style={appearance?.style?.message}
      className={classNames.join(' ')}
    >
      {children}
    </span>
  )
}

export { Message }
